import { BookingLink } from '../booking_link'
import { StartTimeIncrements } from '../start_time_increments'
import { PanelContentContainer } from '../styles'
import { TimezoneDisplay } from '../timezone_display'

export const BookingPageOptions = ({ isLocked }) => (
  <PanelContentContainer>
    <BookingLink isLocked={isLocked} />
    <StartTimeIncrements isLocked={isLocked} />
    <TimezoneDisplay isLocked={isLocked} />
  </PanelContentContainer>
)
